import { createSelector } from 'reselect';

export const selectPhotos = (state) => state.photo;

export const selectPhotoList = (photos) => photos.photoList;

export const selectPhotoListDropzoneVisibility = (photos) =>
  photos && photos.photoListDropzoneVisibility;

export const selectHasStartedFetchPhotos = (photos) =>
  photos && photos.hasStartedFetchPhotos;

export const selectUploadErrorMessage = (photos) => photos && photos.errorMessage;

export const selectHasStartedUploadPhotos = (photos) =>
  photos && photos.hasStartedPhotoUpload;

export const selectHasFinishedUploadPhotos = (photos) =>
  photos && photos.hasFinishedPhotoUpload;

export const selectHasFinishedFetchPhotos = (photos) =>
  photos && photos.hasFinishedFetchPhotos;

export const selectSnackbarState = (photos) =>
  photos && photos.snackbarState;

export const selectLoadingUpload = (photos) =>
  photos && photos.hasNotDataUploadedBeenRetrived;

export const selectLoadingInitial = (photos) =>
  photos && photos.hasNotInitialDataBeenRetrived;

export const selectLastUpload = (photos) =>
  photos && photos.lastUpload;

export const selectHasSnackbar = (photos) =>
  photos && photos.hasSnackbar;

export const selectSnackbarMessage = (photos) =>
  photos && photos.snackbarMessage;

export const selectPhotosToUpload = (photospheres) =>
  photospheres && photospheres.photosToUpload;

export const selectRoomsSuggestions = (photos) =>
  photos && photos.roomsSuggestions;

export const makeSelectPhotoList = () => createSelector(
  selectPhotos,
  selectPhotoList,
);

export const makeSelectHasStartedFetchPhotos = () => createSelector(
  selectPhotos,
  selectHasStartedFetchPhotos,
);

export const makeSelectUploadErrorMessage = () => createSelector(
  selectPhotos,
  selectUploadErrorMessage,
);

export const makeSelectLoadingUpload = () => createSelector(
  selectPhotos,
  selectLoadingUpload,
);

export const makeSelectLoadingInitial = () => createSelector(
  selectPhotos,
  selectLoadingInitial,
);

export const makeSelectLastUpload = () => createSelector(
  selectPhotos,
  selectLastUpload,
);

export const makeSelectPhotoListDropzoneVisibility = () => createSelector(
  selectPhotos,
  selectPhotoListDropzoneVisibility
);

export const makeSelectHasSnackbar = () => createSelector(
  selectPhotos,
  selectHasSnackbar,
);

export const makeSelectSnackbarMessage = () => createSelector(
  selectPhotos,
  selectSnackbarMessage,
);

export const makeSelectSnackbarState = () => createSelector(
  selectPhotos,
  selectSnackbarState,

);
export const makeSelectPhotoHasStartedUplaod = () => createSelector(
  selectPhotos,
  selectHasStartedUploadPhotos
);

export const makeSelectPhotoHasFinishedUplaod = () => createSelector(
  selectPhotos,
  selectHasFinishedUploadPhotos
);

export const makeSelectHasFinishedFetchPhotos = () => createSelector(
  selectPhotos,
  selectHasFinishedFetchPhotos
);

export const makeSelectPhotosToUpload = () => createSelector(
  selectPhotos,
  selectPhotosToUpload
);

export const makeSelectRoomsSuggetions = () => createSelector(
  selectPhotos,
  selectRoomsSuggestions
);
